"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("polyfill");
require("picturefill");
// global.Promise = require('es6-promise').Promise;
/*** node_modules **/
require("jquery.easing");
require("jquery.cookie");
require("@fancyapps/fancybox");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
var size_change_1 = __importDefault(require("size-change"));
var page2top_1 = __importDefault(require("page2top"));
hasher_1.default();
$(function () {
    // new Linker({
    // 	extendLink: '.sw-ExtendLink'
    // });
    new page2top_1.default();
    new size_change_1.default();
    tel_handler_1.default();
    slide_scroll_1.default({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll'
    });
    $('.enq-Q_Item_Header_Img').fancybox({
        animationDuration: 700,
        transitionDuration: 700,
        arrows: false,
        infobar: false,
        smallBtn: false,
        toolbar: true,
        buttons: ['close'],
        idleTime: 999999,
        wheel: false,
        touch: false
    });
});
